// Configuration CinetPay v2
const CINETPAY_CONFIG = {
  apikey: import.meta.env.VITE_CINETPAY_API_KEY || '2699980936909bf80755699.80037643',
  site_id: import.meta.env.VITE_CINETPAY_SITE_ID || '105906962',
  notify_url: `${window.location.origin}/api/cinetpay/notify`,
  return_url: `${window.location.origin}/payment/status`,
  lang: 'FR'
};

// Packs disponibles
const READY_PACKS = {
  "5-stickers": {
    id: "5-stickers",
    name: "Pack Découverte",
    price: 6000,
    quantity: 5,
    description: "5 stickers QR pré-imprimés",
    delivery: "24-48h à Abidjan",
    features: ["5 stickers uniques", "Livraison incluse", "Support par email"],
  },
  "10-stickers": {
    id: "10-stickers",
    name: "Pack Premium",
    price: 10000,
    quantity: 10,
    description: "10 stickers QR pré-imprimés",
    delivery: "24-48h à Abidjan",
    features: ["10 stickers uniques", "Livraison rapide", "Support prioritaire"],
  },
  "20-stickers": {
    id: "20-stickers",
    name: "Pack Pro",
    price: 15000,
    quantity: 20,
    description: "20 stickers QR pré-imprimés",
    delivery: "24-48h à Abidjan",
    features: ["20 stickers uniques", "Livraison express", "Support dédié"],
  },
};

// Méthodes de paiement disponibles
const PAYMENT_METHODS = {
  mobile: {
    name: "Mobile Money",
    description: "Orange Money, Wave, MTN, Moov ",
    icon: "smartphone",
    channels: ['OM', 'MTN', 'MOOV', 'WAVE']
  },
  
};

// Frais de livraison
const DELIVERY_COSTS = {
  'Abidjan': { price: 1500, days: '24-48h', free: false },
  'Yamoussoukro': { price: 2000, days: '2-3 jours', free: false },
  'Bouaké': { price: 2500, days: '2-3 jours', free: false },
  'Daloa': { price: 2500, days: '2-3 jours', free: false },
  'Korhogo': { price: 3000, days: '3-4 jours', free: false },
  'Autre': { price: 3500, days: '3-5 jours', free: false }
};

// Générer un ID de transaction unique
const generateTransactionId = () => {
  return 'CMD_' + Date.now() + '_' + Math.random().toString(36).substr(2, 8).toUpperCase();
};

const cinetpayService = {
  getAvailablePacks() {
    return READY_PACKS;
  },

  getAvailablePaymentMethods() {
    return PAYMENT_METHODS;
  },

  calculateDelivery(city) {
    return DELIVERY_COSTS[city] || DELIVERY_COSTS['Autre'];
  },

  async initPayment(paymentData) {
    try {
      const transactionId = generateTransactionId();
      const amount = Math.round(paymentData.amount);
      
      console.log('🔄 Initialisation paiement:', {
        transactionId,
        amount,
        customer: paymentData.customerName
      });

      // Séparer nom et prénom
      const nameParts = paymentData.customerName.split(' ');
      const firstName = nameParts[0] || 'Client';
      const lastName = nameParts.slice(1).join(' ') || 'Client';

      // Construction de la requête selon la doc CinetPay v2
      const requestData = {
        apikey: CINETPAY_CONFIG.apikey,
        site_id: CINETPAY_CONFIG.site_id,
        transaction_id: transactionId,
        amount: amount,
        currency: 'XOF',
        description: paymentData.description || `Commande ${paymentData.packName}`,
        
        // Informations client (obligatoires pour carte bancaire)
        customer_id: `CUST_${Date.now()}`,
        customer_name: firstName,
        customer_surname: lastName,
        customer_email: paymentData.customerEmail || 'client@example.com',
        customer_phone_number: paymentData.customerPhone,
        customer_address: paymentData.deliveryAddress || 'Abidjan',
        customer_city: paymentData.deliveryCity || 'Abidjan',
        customer_country: 'CI',
        customer_state: 'CI',
        customer_zip_code: '00225',
        
        // URLs
        notify_url: CINETPAY_CONFIG.notify_url,
        return_url: `${CINETPAY_CONFIG.return_url}?transaction_id=${transactionId}`,
        
        // Configuration
        channels: 'ALL',
        lang: CINETPAY_CONFIG.lang,
        
        // Métadonnées
        metadata: JSON.stringify({
          pack_id: paymentData.packId,
          pack_name: paymentData.packName,
          quantity: paymentData.quantity,
          delivery_cost: paymentData.deliveryCost,
          delivery_city: paymentData.deliveryCity
        }),
        
        // CORRECTION: Invoice data avec SEULEMENT 3 items maximum
        invoice_data: {
          "Pack": paymentData.packName,
          "Quantité": paymentData.quantity || 1,
          "Total": `${amount} XOF`
        }
      };

      console.log('📤 Envoi à CinetPay:', requestData);

      // Appel à l'API CinetPay v2
      const response = await fetch('https://api-checkout.cinetpay.com/v2/payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      const result = await response.json();
      console.log('📥 Réponse CinetPay:', result);

      // Traitement de la réponse
      if (result.code === '201' && result.data?.payment_url) {
        // Sauvegarder la transaction
        const orderData = {
          transactionId: transactionId,
          payment_token: result.data.payment_token,
          pack: paymentData.packName,
          amount: amount,
          customer: {
            name: paymentData.customerName,
            phone: paymentData.customerPhone,
            email: paymentData.customerEmail,
            address: paymentData.deliveryAddress,
            city: paymentData.deliveryCity
          },
          status: 'PENDING',
          date: new Date().toISOString()
        };
        
        sessionStorage.setItem(`order_${transactionId}`, JSON.stringify(orderData));
        sessionStorage.setItem('current_transaction_id', transactionId);

        return {
          success: true,
          transactionId: transactionId,
          paymentUrl: result.data.payment_url,
          paymentToken: result.data.payment_token,
          message: 'Redirection vers le paiement...'
        };
      } else {
        // Gestion des erreurs
        const errorMessage = result.message || result.description || 'Erreur lors de l\'initialisation';
        console.error('❌ Erreur CinetPay:', result);
        
        return {
          success: false,
          code: result.code,
          message: errorMessage,
          description: result.description
        };
      }

    } catch (error) {
      console.error('❌ Erreur réseau:', error);
      return {
        success: false,
        message: 'Erreur de connexion au serveur de paiement'
      };
    }
  },

  async checkPaymentStatus(transactionId) {
    try {
      console.log(`🔍 Vérification statut: ${transactionId}`);

      const requestData = {
        apikey: CINETPAY_CONFIG.apikey,
        site_id: CINETPAY_CONFIG.site_id,
        transaction_id: transactionId
      };

      const response = await fetch('https://api-checkout.cinetpay.com/v2/payment/check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      const result = await response.json();
      console.log('📊 Statut paiement:', result);

      let status = 'PENDING';
      let isSuccess = false;

      if (result.code === '00' && result.data) {
        switch(result.data.status) {
          case 'ACCEPTED':
          case 'SUCCESS':
            status = 'SUCCESS';
            isSuccess = true;
            break;
          case 'REFUSED':
          case 'FAILED':
            status = 'FAILED';
            break;
          case 'PENDING':
            status = 'PENDING';
            break;
          default:
            status = result.data.status || 'PENDING';
        }
      }

      return {
        success: isSuccess,
        status: status,
        data: result.data,
        message: result.message || 'Statut vérifié'
      };

    } catch (error) {
      console.error('❌ Erreur vérification:', error);
      return {
        success: false,
        status: 'ERROR',
        message: error.message
      };
    }
  },

  async checkAndUpdatePaymentStatus(transactionId) {
    try {
      const statusResult = await this.checkPaymentStatus(transactionId);
      
      const orderKey = `order_${transactionId}`;
      const savedOrder = sessionStorage.getItem(orderKey);
      
      if (savedOrder) {
        const order = JSON.parse(savedOrder);
        order.status = statusResult.status;
        order.lastCheck = new Date().toISOString();
        
        if (statusResult.success) {
          order.paymentDate = new Date().toISOString();
        }
        
        sessionStorage.setItem(orderKey, JSON.stringify(order));
      }
      
      return statusResult;
      
    } catch (error) {
      console.error('❌ Erreur checkAndUpdatePaymentStatus:', error);
      return {
        success: false,
        status: 'ERROR',
        message: error.message
      };
    }
  },

  getPackById(packId) {
    return READY_PACKS[packId] || READY_PACKS["10-stickers"];
  },

  formatPrice(price) {
    return new Intl.NumberFormat('fr-CI', {
      style: 'currency',
      currency: 'XOF',
      minimumFractionDigits: 0
    }).format(price);
  },

  validatePhoneNumber(phone) {
    const cleanPhone = phone.replace(/\s/g, '');
    return /^(\+225|0|225)[0-9]{8,10}$/.test(cleanPhone);
  }
};

export default cinetpayService;